function CSSvar(name, el = document.documentElement) {
    return getComputedStyle(el).getPropertyValue(name).trim();
}

/**
 *      Bootstrap the CSS custom property breakpoints to window object as raw numbers
 */
const breakpoints = CSSvar('--breakpoint-names').split(',').map((bp) => bp.trim());

window.cssBreakpoints = [];

breakpoints.forEach((bp) => {
    window.cssBreakpoints[bp] = parseInt(CSSvar(`--breakpoint-${bp}`), 10);
});
